import { trackEvent, ACTIONS } from 'common/analytics';

export class OnboardingWizardTracking {
  static CATEGORY = 'onboarding-flow';

  static trackTermsAgreeClick() {
    trackEvent(OnboardingWizardTracking.CATEGORY, ACTIONS.CLICK, 't&c', 'agree-t&c-button');
  }
}
